import {ChangeDetectionStrategy, Component, computed, Signal} from "@angular/core";
import {ActivatedRoute, RouterLink} from "@angular/router";
import {UserService} from "../../../services/user.service";
import {ApartmentService} from "../../../services/apartment.service";
import {validatedNotNull} from "../../../utils";
import {map, switchMap} from "rxjs";
import {toSignal} from "@angular/core/rxjs-interop";
import {
  ApartmentRelevantAdvertisementsPipe,
  RelevantApartmentsInput
} from "../../../pipes/apartment-relevant-advertisements.pipe";
import {RouteDataService} from "../../../services/route-data.service";
import {initialSignupRoute} from "../../signup/specific-signup.routes";
import {
  ApartmentDetailPageContentComponent
} from "../../../components/apartment-detail-page-content/apartment-detail-page-content.component";
import {ButtonDirective} from "primeng/button";
import {AsyncPipe} from "@angular/common";
import {
  ApartmentDetailInfoItemComponent
} from "../../apartments-tab/apartment-detail-page/apartment-detail-info-item/apartment-detail-info-item.component";
import {
  RegularEligibleUnitsComponent
} from "../../../components/apartment-detail-page-content/eligible-units-component/regular-eligible-units.component";
import {SeniorEligibleUnitsComponent} from "../../../components/apartment-detail-page-content/eligible-units-component/senior-eligible-units.component";


@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ApartmentDetailPageContentComponent,
    RouterLink,
    ButtonDirective,
    AsyncPipe,
    ApartmentDetailInfoItemComponent,
    RegularEligibleUnitsComponent,
    SeniorEligibleUnitsComponent,
    ApartmentRelevantAdvertisementsPipe
  ],
  selector: 'homey-apartment-search-detail-page',
  templateUrl: './apartment-search-detail-page.component.html'
})
export class ApartmentSearchDetailPageComponent {
  constructor(private readonly route: ActivatedRoute,
              private readonly apartmentService: ApartmentService,
              private readonly userService: UserService,
              private readonly routeDataService: RouteDataService
              ) {
  }


  protected readonly signupToApplyRoute = computed(
    () => this.routeDataService.routeData().signupToApplyRoute
  )
  protected readonly showCarouselEligibilityCta = computed(
    () => this.routeDataService.routeData().showCarouselEligibilityCta ?? false
  )
  protected readonly user$ = this.userService.user$;
  public readonly apartment$ =
    this.route.paramMap.pipe(
      map(params => validatedNotNull(params.get('lotteryId'))),
      switchMap(apartmentId => this.apartmentService.getApartment(apartmentId))
    );

  private readonly user = toSignal(this.user$);
  private readonly queryParams = toSignal(this.route.queryParamMap);
  protected readonly relevantApartmentsInput: Signal<RelevantApartmentsInput | undefined> = computed(
    () => {
      const size = this.queryParams()?.get('size');
      const lowerIncome = this.queryParams()?.get('lowerIncome');
      const upperIncome = this.queryParams()?.get('upperIncome');

      const user = this.user();
      if (!user) {
        return undefined;
      }
      if (size && lowerIncome && upperIncome) {
        return {
          type: 'specified',
          householdSize: parseInt(size),
          lowerHouseholdIncome: parseInt(lowerIncome),
          upperHouseholdIncome: parseInt(upperIncome),
          receivesRentalAssistance: false,
          eligibleForSenior: true
        };
      } else {
        return {
          type: 'user',
          user: user
        };
      }
    }
  )
  protected readonly initialSignupRoute = initialSignupRoute;
}
